export default __webpack_public_path__ + "static/media/edit_black.c39d3e82.svg";